// extracted by mini-css-extract-plugin
export default {"ErrorHeader":"ErrorBoundary_ErrorHeader__QHT0T","ErrorMessage":"ErrorBoundary_ErrorMessage__+f4AG"};